import EntityConstants from "../configs/EntityConstants";
import { GET } from "../service/CRUDService";

export const fetchCurrentUser = async () => {
  try {
    const response = await GET(EntityConstants.CURRENT_USER);
    if (!response.ok) {
      throw new Error(`Failed to fetch current user: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching current user data:", error);
    return null;
  }
};
